'use strict';

if (!window.i18n) {
    window.i18n = {};
}

if (!window.i18n.languages) {
    window.i18n.languages = {};
}

window.i18n.languages['th_TH'] = {
	vistor_upsucess:"อัปเดตสำเร็จ",
	vistor_accountUp:"อัปเกรดบัญชี",
	vistor_upgradeNow:"อัพเกรดทันที",
	vistor_dear:"เรียนผู้เยี่ยมชม:",
	vistor_suggest:"สวัสดีเพื่อให้คุณได้รับประสบการณ์การใช้งานที่ดีขึ้นฉันขอแนะนำให้คุณ:",
	vistor_click:"คลิก \"อัปเกรดบัญชี\" ด้านล่างเพื่ออัปเกรดเป็นบัญชีอย่างเป็นทางการ",
	vistor_sorry:"ขออภัยบัญชีผู้เยี่ยมชมไม่สามารถเปลี่ยนรหัสผ่านได้เพื่อความปลอดภัยของบัญชีของคุณโปรดอัปเกรดเป็นบัญชีอย่างเป็นทางการ",

	change_useridpwd:"ยืนยันบัญชี",
	bizhong_xuanze: "ตัวเลือกสกุลเงิน",

	optional:"ไม่จำเป็น",
	needBet: "ยังคงต้องเดิมพัน:",
	needDeposit:"ยังไงก็ต้องฝาก:",
	agentCode : "รหัสเชิญ",
	tips_fail:"การอ้างสิทธิ์ล้มเหลว",

	a_stauts: "สถานะกิจกรรม",
	activityDetails_hdjxz: "กำลังดำเนินการกิจกรรม",
	activityDetails_hdwks: "กิจกรรมยังไม่เริ่ม",
	activityDetails_hdyjs: "กิจกรรมสิ้นสุดแล้ว",
	a_time: `เวลากิจกรรม`,
	a_status: `สถานะใช้งาน`,
	a_rule: `กฎการให้รางวัล`,
	a_content: `รายละเอียดกิจกรรม`,


	gameCoin:"สกุลเงินของเกม",
	register_chooseCurrency: "เลือกสกุลเงินฝาก",
	register_tips0:"*ไม่อนุญาตให้เปลี่ยนสกุลเงินหลังการลงทะเบียน",
	register_curInstruction:"คำอธิบายสกุลเงิน:",
	register_tips1:"1. เมื่อเข้าสู่เกมที่ไม่รองรับสกุลเงินปัจจุบันของผู้ใช้,จำนวนเงินที่แปลงตามอัตราแลกเปลี่ยนจะถูกนำเข้าสู่เกม",
	register_tips2:" 2. วิธีการฝาก / ถอนของผู้ใช้คือการแสดงการรองรับสกุลเงินปัจจุบันของผู้ใช้",

	sendSuccess:"ส่งเรียบร้อยแล้ว!",
	login_areaCode: 'รหัสประเทศ',
	login_selectAreaCode: 'เลือกประเทศหรือภูมิภาค',
	new_maxVipLV: 'ยินดีด้วย! ! ขณะนี้คุณอยู่ในระดับสูงสุด',
	currency_symbol : "฿",
	language : "ไทย",

	new_r_rate: 'จำนวนเงินที่นำเข้าสู่เกมคือจำนวนเงินหลังจากการแปลงอัตราแลกเปลี่ยน',
	new_r_rate1: 'อัตราแลกเปลี่ยน：',
	new_r_money: 'จำนวนเงินที่เข้าสู่เกม：',
	new_r_tips6: '*โปรดทราบว่าถ้าคุณเปลี่ยนเกมไตรภาคีคุณสามารถนำจำนวนเต็ม',
	new_r_tips7: 'การแจ้งเตือนอัตราแลกเปลี่ยน',
	new_r_tips8: 'ฉันรู้ว่า',
	new_r_tips9: 'คุณกำลังเข้าสู่',
	new_r_game: "เกม",


	"ActivityNew": {
	"btn_lingqu": "เรียกร้องทันที",
	"btn_back": "วกกลับ",
	"toggle_zonghe": "กิจกรรมที่ครอบคลุม"
	},
	"SignIn": {
		"btnLingqu": "ได้รับ"
	},
	"label_text": {
		"loading_msg": "กำลังดาวน์โหลดชุดทรัพยากรการอัปเดตสำหรับคุณ",
		"not_logged": "ยังไม่ล็อกอิน",
		"password": "รหัสผ่าน：",
		"verify": "รหัสยืนยัน：",
		"verify_msg": "กรุณาป้อนรหัสยืนยัน",
		"inPlease_enter_the": "กรุณาป้อน",
		"phone": "มือถือ",
		"No": "เปอร์",
		"determine": "ยืนยัน",
		"receive": "รับ",
		"Image_preview": "ดูภาพตัวอย่าง Avatar",
		"Install": "ติดตั้งทันที",
		"obtain": "ขอแสดงความยินดีที่คุณได้รับ",
		"check_update": "กำลังตรวจสอบและทำการอัปเดตอยู่...",
		"real_name": "ชื่อจริง",
		"tips": "ต่อต้านเกมที่ไม่ดี  ปฏิเสธเกมที่ละเมิดลิขสิทธิ์   ให้ความสนใจกับการป้องกันตนเองและระวังการถูกหลอก  การเล่นเกมในระดับปานกลางมีประโยชน์ต่อสมองดื่มด่ำกับเกม จัดเวลาอย่างมีเหตุผลและสนุกกับชีวิตที่มีสุขภาพดี ",
		"no_data": "ไม่มีข้อมูล",
		"queding": "บันทึก",
		"quxiao": "ยกเลิก",
		"online_kefu": "แชทสด",
		"title": "ได้รับรางวัล",
		"tishi": "ทูลเกล้าฯถวาย",
		"download_new_version": "กรุณาดาวน์โหลดรุ่นล่าสุดของโปรแกรมที่จะใช้คุณลักษณะนี้",
		"save_account": "เก็บข้อมูลบัญชี"
	},
	"data_req_text": {
		"login_failure": "การเข้าสู่ระบบหมดเวลา  โปรดเข้าสู่ระบบอีกครั้ง"
	},
	"login_text": {
		"account_pro": "เลขที่บัญชีต้องมี  กรุณากรอกด้วย",
		"psw_pro": "รหัสผ่านต้องมี  กรุณากรอกด้วย",
		"vfy_pro": "รหัสยืนยันต้องมี  กรุณากรอกด้วย",
		"quick_login_fail": "การเข้าสู่ระบบของผู้เยี่ยมชมล้มเหลว",
		"account": "บัญชี：",
		"account_msg": "โปรดป้อนบัญชี / หมายเลขโทรศัพท์ ",
		"paw_msg": "โปรดป้อนรหัสผ่าน",
		"Remember_acc": "จดจำบัญชีไว้",
		"forget_paw": "ลืมรหัสผ่านหรือ",
		"no_acc": "ไม่มีเลขที่บัญชี",
		"go_reg": "ไปที่การลงทะเบียน>",
		"confirm_login": "ยืนยันการเข้าสู่ระบบ",
		"quick_login": "บุคคลทั่วไปเข้าสู่ระบบ",
		"confirm_register": "ยืนยันการลงทะเบียน",
		"register_cg": "ลงทะเบียนเรียบร้อยแล้ว",
		"account_data": "รายละเอียดบัญชี",
        "sfyz": "รับรองความถูกต้อง",
        "sfyz_tip": "สวัสดีลูกค้าที่เคารพ เพื่อปกป้องบัญชีของคุณเข้าสู่ระบบนี้ต้องมีการตรวจสอบต่อไปนี้เพื่อป้องกันโปรแกรมที่เป็นอันตรายจากการเข้าสู่ระบบโดยอัตโนมัติ",
        "bind_bank": "กรุณาใส่บัตรผูกธนาคาร",
        "bind_alipay": "กรุณาป้อนสมบัติผูกพันที่จะจ่าย",
        "bank_card": "บัตรเครดิตธนาคาร",
        "alipay": "จ่ายสมบัติ",
        "code": "รหัสการตรวจสอบ",
        "enter_bank_card": "กรุณาใส่หมายเลขบัตรของธนาคาร",
        "enter_alipay": "กรุณาระบุบัญชีการชำระเงิน",
        "enter_code": "กรุณาใส่รหัสการตรวจสอบ",
	},
	"register_text": {
		"perfect_suc": "ความสำเร็จในการปรับปรุงข้อมูลให้สมบูรณ์",
		"perfect_err": "ไม่สามารถทำการปรับปรุงข้อมูลให้สมบูรณ์แบบ",
		"inp_data": "ปรดป้อนข้อมูลก่อน",
		"inp_email": "โปรดป้อนอีเมล",
		"inp_phone": "โปรดป้อนหมายเลขโทรศัพท์ของคุณ",
		"inp_wx": "โปรดป้อน WeChat ID",
		"inp_qq": "โปรดป้อนหมายเลข QQ",
		"email": "อีเมล：",
		"wx_No": "WeChat：",
		"qq_No": "หมายเลข QQ：",
		"phone": "หมายเลขโทรศัพท์มือถือ：",
		"user_name": "ชื่อผู้ใช้：",
		"user_msg": "ชป้อนตัวอักษรหรือตัวเลข 6-12 หลัก",
		"user_pro": "รหัสผ่าน 6-12 ตัวอักษรหรือตัวเลขหรือสัญลักษณ์\n",
		"paw_pro": "รหัสผ่านประกอบด้วยตัวเลขและตัวอักษร 6-12 หลัก",
		"confirm_paw_pro": "การยืนยันรหัสผ่านต้องมี  กรุณากรอกเข้า",
		"paw_consistent": "รหัสผ่านและรหัสผ่านที่ยืนยันไม่สอดคล้องกัน  โปรดกรอกอีกครั้ง",
		"paw_msg": "โปรดป้อนรหัสผ่านที่ประกอบด้วยตัวอักษรและตัวเลข 6-12 ตัว",
		"confirm_msg": "โปรดยืนยันรหัสผ่านของคุณอีกครั้ง",
		"phone_msg": "โปรดป้อนรหัสยืนยันจากโทรศัพท์",
		"con_paw": "ยืนยันรหัสผ่าน：",
		"exi_acc": "บัญชีมีอยู่แล้ว，",
		"go_log": "ไปที่การเข้าสู่ระบบ>",
		"send_verify": "ส่ง",
		"retry_verify": "ส่งใหม่",
		"phone_confirm": "ป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
		"register_suc": "ลงทะเบียนสำเร็จแล้ว",
		"user_not_mag": "ชื่อของผู้ใช้ต้องมี  กรุณากรอก",
		"No_null": "เบอร์โทรต้องมี  กรุณากรอก",
		"correct_phone": "ป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
		"phone_vfy": "รหัสยืนยันโทรศัพท์มือถือต้องมี  กรุณากรอก",
		"loss_account": "เพื่อป้องกันไม่ให้บัญชีสูญหาย โปรดบันทึกบัญชีไว้",
		"account_change": "บัญชีสามารถแก้ไขได้เพียงครั้งเดียว  คลิกเพื่อแก้ไข",
		"please_tick": "โปรดคลิกปุ่มทำเครื่องหมายเพื่อยืนยันรหัสผ่านบัญชีของคุณ",
		"save_suc": "บันทึกสำเร็จ",
		"save_err": "บันทึกล้มเหลว,โปรดถ่ายภาพหน้าจอด้วยตนเอง!",

		"currency": "สกุลเงิน",
		"language": "ภาษา",
	},
	"datum_text": {
		"datum_title": "ส่งข้อมูล",
		"bank_card": "หมายเลขบัตรเครดิตธนาคาร：",
		"inPlease_enter_the": "โปรดป้อน...",
		"input_datum": "โปรดป้อนข้อมูลก่อน",
		"update_img": "อัปโหลดภาพ",
		"select_update_img": "โปรดเลือกภาพที่อยากจะอัปโหลด",
		"limit_type": "อัปโหลดเฉพาะแบบJPG、JPEG、PNGเท่านั้น",
		"msg_update_data": "โปรดอัปโหลดข้อมูลก่อน",
		"mag_update_pic": "โปรดอัปโหลดรูปภาพในรูปแบบที่ถูกต้องก่อน",
		"apply_succ": "ส่งแอปพลิเคชันสำเร็จ  โปรดรอการตรวจสอบ"
	},
	"task_text": {
		"activity": "กิจกรรม",
		"task": "งาน",
		"announcement": "ประกาศ",
		"sign": "ลงชื่อรายงาน",
		"task_name": "ชื่องาน：",
		"task_detail": "รายละเอียดงาน",
		"task_time": "เวลาที่มีผลกับงาน：",
		"task_content": "เนื้อหางาน："
	},
	"customer_text": {
		"jump_whatsapp": "คัดลอกบัญชี whatsapp สำเร็จแล้ว  ขอข้ามไปเข้าที่ whatsapp",
		"jump_telegram": "คัดลอกบัญชี telegram สำเร็จแล้ว  ขอข้ามไปเข้าที่ telegram",
		"jump_Messenger": "คัดลอกบัญชี Messenger สำเร็จแล้ว  ขอข้ามไปเข้าที่ Messenger",
		"jump_Viber": "คัดลอกบัญชี Viber สำเร็จแล้ว  ขอข้ามไปเข้าที่ Viber",
		"no_whatsapp": "เครื่องของคุณยังไม่ได้ติดตั้ง whatsapp",
		"no_telegram": "เครื่องของคุณยังไม่ได้ติดตั้ง telegram",
		"no_Messenger": "เครื่องของคุณยังไม่ได้ติดตั้ง Messenger",
		"no_Viber": "เครื่องของคุณยังไม่ได้ติดตั้ง Viber",

		"contact_customer": "ติดต่อฝ่ายบริการลูกค้า",
		"not_ind_qq": "เครื่องของคุณยังไม่ได้ติดตั้ง QQ",
		"jump_wx": "คัดลอกบัญชี WeChat สำเร็จแล้ว  ขอข้ามไปเข้าที่ WeChat",
		"not_ind_wx": "เครื่องของคุณยังไม่ได้ติดตั้งWeChat",
		"jump_mt": "บัญชีบริการลูกค้าของ MT ถูกคัดลอกสำเร็จแล้ว  ขอข้ามไปยังบริการลูกค้า MT",
		"Online": "บริการลูกค้าออนไลน์",
		"QQ": "การบริการลูกค้าใน QQ",
		"WECHAT": "การบริการลูกค้าในWeChat",
		"MT": "บริการลูกค้า MT",
		"CJ": "ปัญหาที่พบบ่อย",
		"contact_online": "ติดต่อฝ่ายบริการลูกค้า",
		"copy_wx": "คัดลอก WeChat ID",
		"copy_mt": "คัดลอกหมายเลข MT"
	},
	"msg_text": {
		"save_date": "ข้อความสามารถบันทึกไว้นานสุดหนึ่งเดือน",
		"message": "ข้อความ",
		"email": "เมล",
		"receive": "ได้รับแล้ว",
		"overdue": "เกินอายุใช้งานแล้ว",
		"not_delete": "ไม่สามารถลบได้  โปรดเก็บรางวัลก่อน",
		"not_be_deleted": "เมลที่ไม่มีการอ้างสิทธิ์จะไม่ถูกลบไป"
	},
	"basic_text": {
		"basic_title": "ข้อมูลพื้นฐาน",
		"account": "หมายเลขบัญชี：",
		"nickname": "ชื่อเล่น：",
		"name": "ชื่อและนามสกุล：",
		"com_title": "ข้อมูลการสื่อสาร",
		"qq": "Q Q：",
		"wx": "WeChat：",
		"phone": "โทรศัพท์มือถือ：",
		"email": "มีเมล："
	},
	"baes_text": {
		"unit": "หยวน",
		"view": "เปิดดู 》",
		"yes": "ใช่",
		"no": "ไม่ใช่",
		"update": "อัปเดต",
		"cancel": "ยกเลิก",
		"mail_system": "อีเมลที่มาจากระบบ",
		"connected": "กำลังเชื่อมต่ออยู่  โปรดอดใจรอ...",
		"coin": "เหรียญทอง"
	},
	"pre_details_text": {
		"lxkf": "ติดต่อฝ่ายบริการลูกค้า ",
		"rkz": "กำลังมีเงินเข้า...",
		"copy": "คัดลอก",
		"order": "หมายเลขคำสั่งซื้อ",
		"date": "เวลาเติมเงิน",
		"czType": "วิธีการเติมเงิน",
		"transfer": "โอนเงิน",
		"succ": "สำเร็จ",
		"error": "ล้มเหลว",
		"audit": "กำลังการตรวจสอบ",
		"czSucc": "การเติมล้มเหลว",
		"copy_succ": "คัดลอกสำเร็จ",
		"order_num": "หมายเลขคำสั่งซื้อ",
		"detail": "รายละเอียดค่าใช้จ่าย"
	},
	"USDT_text": {
		"second_step": "ขั้นตอนที่ ๒: ข้อมูลโซ่ USDT",
		"url_name": "ชื่อโซ่",
		"alipay": "ชำระเงินด้วยอาลีเพย์",
		"url": "ที่อยู่โซ่..."
	},
	"set_text": {
		"set_music": "การตั้งค่าเพลง",
		"switch_music": "การเปลี่ยนเพลง",
		"change_d_paw": "เปลี่ยนรหัสผ่านการเข้าสู่ระบบ",
		"change_t_paw": "เปลี่ยนรหัสผ่านการถอนเงินสด",
		"version": "เวอร์ชันปัจจุบัน",
		"huidu": "รุ่นสีเทา",
		"swi_test": "ต้องการเปลี่ยนเป็นเวอร์ชั่นทดสอบหรือไม่",
		"swi_hui": "จะเปลี่ยนเป็นรุ่นโทนสีเทาหรือไม่",
		"old_paw_null": "รหัสผ่านเก่าต้องมี  กรุณากรอก",
		"new_paw_null": "รหัสผ่านใหม่ต้องมี  กรุณากรอก",
		"old_paw_limit_length": "รหัสผ่านเก่าคือ 6-12 หลัก",
		"new_paw_limit_length": "รหัสผ่านเก่าคือ 6-12 หลักซึ่งประกอบด้วยตัวเลขกับตัวอักษร",
		"new_paw_limit": "รหัสผ่านเก่าควรเป็นตัวเลข 6 หลัก  โปรดกรอกข้อมูลอีกครั้ง",
		"con_paw_null": "รหัสผ่านการยืนยันต้องมี  กรุณากรอก",
		"con_paw_consistent": "รหัสผ่านและรหัสผ่านที่ยืนยันไม่สอดคล้องกัน  โปรดกรอกอีกครั้ง",
		"new_old_paw_consistent": "รหัสผ่านใหม่ไม่สามารถเหมือนกันกับรหัสเก่า  กรุณากรอกอีกครั้ง",
		"change_succ": "ขอแสดงความยินดีที่คุณเปลี่ยนรหัสผ่านเรียบร้อยแล้ว  โปรดลงชื่อเข้าใช้อีกครั้ง",
		"tx_paw_null": "รหัสผ่านการถอนเงินสดต้องมี  กรุณากรอก",
		"con_tx_paw": "ยืนยันว่ารหัสผ่านการถอนต้องมี  กรุณากรอก",
		"tx_paw_consistent": "รหัสผ่านการถอนและรหัสผ่านยืนยันไม่สอดคล้องกัน  โปรดยืนยันอีกที",
		"tx_paw_limit": "รหัสผ่านการถอนควรเป็น 6 หลัก  กรุณากรอกอีกครั้ง",
		"paw_change_succ": "ขอแสดงความยินดีกับที่คุณเปลี่ยนรหัสผ่านเรียบร้อยแล้ว",
		"latest_version": "นี่เป็นแอพเวอร์ชั่นล่าสุด",
		"switch_server": "สลับเซิร์ฟเวอร์",
		"switch_language": "เปลี่ยนภาษา",
		"change_language_tips": "บางส่วนของหน้าภาษาจะมีผลเมื่อรีสตาร์ทโปรแกรม",
		"restart": "เริ่มใหม่"
	},
	"share_text": {
		"copy_wa": "คัดลอกบทเขียน",
		"save_img": "บันทึกรูปภาพ",
		"share_py": "แบ่งปันเข้ากลุ่มเพื่อน",
		"submit_audit": "ส่งเพื่อตรวจสอบ",
		"copy_succ": "คัดลอกสำเร็จ",
		"save_img_succ": "บันทึกภาพรูปสำเร็จ",
		"save_err": "ไม่สามารถบันทึกรูปภาพได้  โปรดไปที่หน้าการตั้งค่าโทรศัพท์เพื่อเปิดการอนุญาตของแอพพลิเคชั่นนี้ในการจัดเก็บรูปภาพ",
		"share_go": "แชร์ไปที่：",
		"share_err_qq": "การแบ่งปันล้มเหลว  โปรดติดตั้งหรือตรวจสอบ QQ แล้วลองอีกครั้ง",
		"share_err_wx": "การแบ่งปันล้มเหลว  โปรดติดตั้งหรือตรวจสอบ WeChat แล้วลองอีกครั้ง",
		"share_err_wl": "การผูกพันล้มเหลว  โปรดตรวจสอบเครือข่ายแล้วลองอีกครั้ง",
		"shareIntroduce_title": "แบ่งปันกวดวิชา",
		"inviteFriends": "เชิญเพื่อน"
	},
	"hot_text": {
		"dzyx": "การรวบรวมวิดีโอเกมยอดนิยมจากทั่วทุกมุมโลก  ความกระตือรือร้นไม่ลดน้อยลง  อัตราการชนะสูงกว่าและของขวัญนับสิบล้านกำลังรอให้คุณมารับ",
		"qbyx": "การรวบรวมเกมหมากรุกและการ์ดยอดนิยมจากทั่วโลก  ความกระตือรือร้นไม่ลดน้อยลง  อัตราการชนะสูงขึ้นและของขวัญนับสิบล้านกำลังรอให้คุณมารับ",
		"byyx": "การรวบรวมเกมตกปลายอดนิยมระดับโลก  ความกระตือรือร้นไม่ลดน้อยลง  อัตราการชนะสูงขึ้นและคุณกำลังรอให้คุณได้รับของรางวัลนับสิบล้าน",
		"rmdz": "อิเล็กทรอนิกส์",
		"rmqp": "หมากรุกร้อน",
		"rmby": "ปลาร้อน",
		"ljyx": "เกมทันที"
	},
	"agent_text": {
		"my_id": "ID ของฉัน：",
		"under": "ค่าคอมมิชชั่นโดยตรงของเมื่อวาน：",
		"offline": "คอมมิชชั่นออฟไลน์ของเมื่อวานนี้：",
		"under_player": "ผู้เล่นที่โดยตรง：",
		"day_new": "เพิ่งเพิ่มของเมื่อวานนี้：",
		"offline_player": "ผู้เล่นออฟไลน์：",
		"bind_wx": "ผูกกับ WeChat",
		"share_rewards": "แบ่งปันรางวัล：",
		"commission_ins": "ในวันชำระค่าคอมมิชชั่นคือการชำระรายวันการแชร์กับเพื่อน   หรือแวดวงเพื่อนสามารถรับรางวัลการแบ่งปันได้"
	},
	"vip_text": {
		"title": "ของฉันVIP",
		"backToMe": "หน้าหลัก",
		"me": "ของฉัน",
		"my_level": "ระดับของฉัน：",
		"current_code": "ปริมาณโค้ดปัจจุบัน：",
		"was_filed": "เลื่อนระดับเป็นแจ็คพอต",
		"was_filed_info": "สามารถรับรางวัลได้เมื่อคุณเลื่อนขั้น",
		"weeks_amounts": "ของขวัญประจำสัปดาห์",
		"weeks_amounts_info": "แจกจ่ายฟรีทุกวันจันทร์",
		"month_amounts": "เงินของขวัญรายเดือน",
		"month_amounts_info": "จำนวนเงินที่ออกตรงเวลาในวันที่ 1 ของแต่ละเดือน",
		"wash_code": "ล้างโค้ด",
		"wash_code_info": "อัตราส่วนการล้างสูงสุด",
		"but_text": "ไปตอนนี้เลย",
		"get_error": "ไม่สามารถรับเหรียญทองได้  โปรดรีเฟรชเหรียญทองอีกครั้ง",
		"amount_code": "จำนวนโค้ด"
	},
	"xima_text": {
		"game_type": "ประเภทเกม",
		"dm_total": "จำนวนเงินเดิมพันที่มีผล",
		"proportion": "อัตราส่วนการสับสูงสุด",
		"xm_amount": "จำนวนล้างโค้ด",
		"can_led_take": " สามารถรับได้",
		"xm_total": "ยอดจำนวนล้างโค้ด"
	},
	"PlayerCenter": {
		"jbxx": "ประวัติของฉัน",
		"zhmx": "รายการธุรกรรม ",
		"zdlb": "บันทึกการเดิมพัน",
		"my_vip": "ของฉันVIP",
		"save": "บันทึก",
		"edit": "แก้ไข ",
		"note": "หมายเหตุ",
		"betting_record": "บันทึกการเดิมพัน",
		"trading_hours": "เวลาการซื้อขาย",
		"trading_type": "ประเภทการซื้อขาย",
		"change_amount": "การเปลี่ยนแปลงจำนวนเงิน",
		"balance": "สมดุล",
		"today": "วันนี้",
		"yesterday": "เมื่อวานนี้",
		"a_month": "หนึ่งเดือน",
		"all": "ทั้งหมด",
		"status": "สถานะธุรกรรม",
		"chess": "บัตรหมากรุก",
		"send_time": "เวลาชำระเงิน",
		"note_num": "เกม—บันทึกหมายเลข",
		"betting_amount": "จำนวนเงินเดิมพัน",
		"has_been": "แจกรางวัลแล้ว",
		"gaming": "แพลตฟอร์มเกม",
		"currencyType":"แปลงสกุลเงิน",

	},
	"RechargeLayer": {
		"note": "หมายเหตุ",
		"often_play": "จำนวนที่รวดเร็วสะดวกที่ผู้เล่นมักเล่นบ่อย",
		"between": "โปรดป้อนจำนวนระหว่าง 1 ~ 100",
		"gift100": "แถม100%",
		"payment_account": "บัญชีการชำระเงิน",
		"payee": "ผู้รับเงิน",
		"where": "ธนาคารที่เปิดบัญชี",
		"depositors": "กรุณากรอกชื่อจริงของผู้ฝาก",
		"note_info": "ข้อมูลบันทึกย่อ",
		"step": "ขั้นตอนแรก: สแกนรหัส QR ของการชำระเงินและเติมเงิน",
		"step2": "ขั้นตอนที่ ๒: กรอกข้อมูลการเติมเงินของคุณและส่งการเติมเงิน",
		"session": "เซสชันล่าสุด",
		"official": "ใบรับรองอย่างเป็นทางการ",
		"gift2": "แถม2%",
		"channel": "*โปรดเลือกช่องเติมเงิน  n * โปรดตรวจสอบอัตราแลกเปลี่ยนอย่างรอบคอบก่อนเลือกช่อง",
		"qr_code": "เก็บรักษา  n บันทึก  n สอง  n ขนาด  n โค้ด",
		"digital_currency": "ช่องเติมเงินสกุลดิจิตอล 1",
		"step_1": "ขั้นตอนที่ 1: เลือกจำนวนเงิน USDT",
		"formula": "สูตรการคำนวณสำหรับการเติมเงินครั้งสุดท้ายจำนวนบัญชีคือ: 70.86 = 10.1234USDT * อัตราแลกเปลี่ยนปัจจุบัน 7 หยวน",
		"step3": "ขั้นตอนที่ 3: ระบุข้อมูลการถอน",
		"actual_account": "จำนวนเงินของ USDT ที่ได้รับจริง",
		"poundage": "ค่าธรรมเนียม 0-50USDT",
		"instr": "*กรุณากรอกอย่างเคร่งครัดตามที่แสดงในภาพทางด้านซ้าย!  n * หากคุณกรอกไม่ถูกต้องจะไม่ได้รับตรงเวลา!",
		"not_account": "การเติมเงินยังไม่เข้าหรือ",
		"rate": "อัตราแลกเปลี่ยน：1USDT=99หยวน",
		"prompt_info": "ข้อความเตือน",
		"save_code": "กดค้างเพื่อบันทึกรหัส QR",
		"date": "เวลา",
		"jine": "จำนวน",
		"currency_symbol": "฿",
		"currency_word": "THB",
		"czjl": "บันทึกค่าใช้จ่าย",
		"czjc": "กวดวิชาเติมเงิน",
		"ljcz": "เติมทันที",
		"czje": "คิดผลรวม",
		"zfpz": "ใบรับรองการชำระเงิน",
		"xuanchuan": "เจ้าหน้าที่เติมเงิน\n        รับประกันความน่าเชื่อถือสัมบูรณ์",
		"usdt_address": "ที่อยู่เติม USDT",
		"syb": "ก้าวไปข้างหน้า",
		"complete": "เสร็จสิ้น",
		"usdt_num": "ค่าใช้จ่าย USDT",
		"go_recharge": "เติม",
		"back": "วกกลับ",
		"creat_order": "สร้างใบสั่งซื้อ",
		"real_usdt": "บัญชีจริงจำนวน usdt",
		"sxf": "ค่าธรรมเนียม",
		"state": "สภาพ",
		"detail": "รายละเอียด",
		"rechargeCourse": "กวดวิชาเติมเงิน",
		"rate2coin": "อัตราแลกเปลี่ยนเหรียญทอง ",
		"get_coins": "เหรียญทองในบัญชี",
		"get_money": "จำนวนเงินในบัญชี",
        "go_pay": "สำเนาสำเร็จคุณต้องการชำระเงินทันทีหรือไม่?",
        "pay_now": "จ่ายทันที",
        "pay_not_support": "ไม่สามารถชำระเงินได้ชั่วคราว!",
	},
	"SettingLayer": {
		"bind_equi": "การผูกกับเครื่อง",
		"basic_info": "ข้อมูลพื้นฐาน",
		"account": "หมายเลขบัญชี：",
		"level": "ระดับ：",
		"set_sound": "การตั้งค่าเสียง",
		"music": "เพลง",
		"sound": "เสียงประกอบ",
		"switch_music": "การสลับเพลง",
		"song2": "รักเมื่อคุณตาย",
		"song1": "เพลงที่ 1",
		"inp_landing_paw": "โปรดป้อนรหัสผ่านการเข้าสู่ระบบ",
		"inp_old_paw": "โปรดป้อนรหัสผ่านเก่า",
		"old_paw": "รหัสผ่านเก่า：",
		"inp_new_paw": "โปรดป้อนรหัสผ่านใหม่",
		"new_paw": "รหัสผ่านใหม่：",
		"con_new_paw": "ยืนยันรหัสผ่านใหม่",
		"con_paw": "ยืนยันรหัสผ่าน：",
		"check_update": "ตรวจสอบเพื่ออัปเดต",
		"determine": "ยืนยัน",
		"bind_shuom1": "*หลังจากเชื่อมต่อกับเครื่องแล้ว  คุณสามารถใช้การเข้าสู่ระบบอย่างรวดเร็วเพื่อเข้าสู่เครื่องที่เชื่อมโยงโดยตรง",
		"bind_shuom2": "*โดยการเข้าสู่ระบบอย่างรวดเร็วเพื่อลงทะเบียนบัญชีเครื่องปัจจุบันจะถูกผูกไว้โดยอัตโนมัติ",
		"bind_shuom3": "*หลังจากเชื่อมเครื่องคุณสามารถตรวจสอบข้อมูลประจำตัวและยกเลิกการผูก",
		"bind_shuom4": "*ในการยืนยันตัวตนของคุณคุณต้องป้อนรหัสผ่านเข้าสู่ระบบของบัญชีของคุณ",
		"bind_shuom5": "*โปรดใช้งานความระมัดระวัง",
		"bind_shuom6": "ได้ผูกกับเครื่องปัจจุบันแล้ว",
		"bind_shuom7": "ได้ผูกกับเครื่องอื่นแล้ว",
		"landing_paw": "รหัสเข้าสู่ระบบ：",
		"test": "การทดสอบสิ่งแวดล้อม",
		"huidu": "สิ่งแวดล้อมสีเทา",
		"standbyTest": "สภาพแวดล้อมการทดสอบสแตนด์บาย",
		"mute_all": "เงียบทั้งหมด",
		"change_account": "เปลี่ยนบัญชี",
		"confirm_change": "ยืนยันการเปลี่ยนแปลง",
		"confirm_bind": "อุปกรณ์ผูกพัน",
		"unbind_device": "ปลดล็อคอุปกรณ์ผูกพัน",
		"unbind": "ยกเลิกการผูกมัด"
	},
	"Task": {
		"share_task": "แบ่งปันงาน",
		"MG_electronic": "MGอิเล็กทรอนิกส์",
		"cash": "เงินสด",
		"complete": "เพื่อให้เสร็จสมบูรณ์",
		"application": "กำลังสมัคร",
		"refused": "ปฏิเสธแล้ว",
		"disclose_data": "ส่งข้อมูล",
		"submit": "ส่ง",
		"Audit_failure": "การตรวจสอบล้มเหลว",
		"friends_account": "ส่งภาพหน้าจอ",
		"apply_reward": "สมัครรับรางวัล",
		"pic_limit": "อัปโหลดได้ JPG, JPEG, PNG, เท่านั้นและไม่เกิน 1M ",
		"update_pic": "อัปโหลดรูปภาพ",
		"task_details": "รายละเอียดงาน",
		"Task_details": "รายละเอียดงาน：",
		"task_name": "ชื่องาน：",
		"task_state": "คำอธิบายงาน：",
		"share": "แชร์",
		"task_progress": "ความคืบหน้างาน：",
		"know": "ฉันรู้",
		"q_update_pic": "โปรดอัปโหลดรูปภาพก่อน",
		"activit_Shut": "กิจกรรมงานถูกปิดแล้ว",
		"Qbind_wx": "โปรดผูกกับ WeChat ก่อน",
		"Application_success": "แอปพลิเคชันสำเร็จโปรดรอการตรวจสอบ",
		"Succ_application_Award": "การสมัครรางวัลสำเร็จ",
		"task_ShutDown": "งานการแชร์ถูกปิดแล้ว",
		"btn_choose": "คัดเลือก",
		"editTips": "โปรดเลือกภาพที่อัพโหลด"
	},
	"ThirdGamesListLayer": {
		"xsj": "หมากรุกโลกใหม่",
		"tall_game": "เกมทั้งหมด 1 เกม",
		"inp_game": "โปรดป้อนชื่อเกม"
	},
	"TuiGuangLayer": {
		"title": "ทำเงิน",
		"my_agent": "ตัวแทนของฉัน",
		"agent_recruit": " โปรโมชั่นของฉัน ",
		"agent_introduced": "การแนะนำตัวแทน",
		"players_query": "ข้อความค้นหาของผู้เล่น",
		"results_query": "ข้อความค้นหาประสิทธิภาพ",
		"rich_list": "การจัดอันดับความมั่งคั่ง",
		"my_id": "ID ของฉัน：",
		"under": "ค่าคอมมิชชั่นโดยตรงของเมื่อวาน：",
		"offline": "คอมมิชชั่นออฟไลน์ของเมื่อวานนี้：",
		"under_player": "ผู้เล่นที่โดยตรง：",
		"day_new": "เพิ่งเพิ่มของเมื่อวานนี้：",
		"offline_player": "ผู้เล่นออฟไลน์：",
		"share_rewards": "แบ่งปันรางวัล：",
		"commission_ins": "ในวันชำระค่าคอมมิชชั่นคือการชำระรายวันการแชร์กับเพื่อน   หรือแวดวงเพื่อนสามารถรับรางวัลการแบ่งปันได้",
		"save_qr_code": "บันทึกรหัส QR",
		"copy": "คัดลอก",
		"bind_wx": "ผูกกับ WeChat",
		"Imm_receive": "รับทันที",
		"share_detail": "แชร์รายละเอียด",
		"get_record": "บันทึกการรับ",
		"zhishu_renshu": "จำนวนคนโดยตรง：",
		"tall_bets_today": "การเดิมพันทั้งหมดมีผลใช้ได้ในวันนี้：",
		"inp_id": "โปรดป้อน ID",
		"query": "ค้นหา",
		"reset": "รีเซ็ต",
		"bets_today": "เดิมพันได้แล้ววันนี้",
		"total_bets": "การเดิมพันที่มีประสิทธิภาพทั้งหมด",
		"directly_num": "จำนวนคนโดยตรง",
		"operation": "การดำเนินงาน",
		"details": "รายละเอียด >>",
		"date": "วันที่",
		"under_new": "เพิ่งเพิ่มใหม่ภายใต้",
		"team_new": "เพิ่งเพิ่มใหม่ของทีม",
		"directly_under": "การคืนค่าคอมมิชชั่นโดยตรง",
		"total_amount": "ยอดการคืนค่าคอมมิชชั่น",
		"reward": "รางวัล",
		"ranking": "อันดับ",
		"player_info": "ข้อมูลของผู้เล่น",
		"rebate_month": "รางวัลในการคืนค่าคอมมิชชั่นของเดือนนี้",
		"rewards_month": "แบ่งปันรางวัลในเดือนนี้",
		"detailed_info": "ข้อมูลโดยละเอียด",
		"zhuce_shijian": "เวลาลงทะเบียน：",
		"jtyxtz": "การเดิมพันที่มีผลใช้ได้ในวันนี้：",
		"tdrsxz": "จำนวนสมาชิกในทีม (เพิ่มใหม่)：",
		"jrtdyxtz": "การเดิมพันที่ถูกต้องของทีมวันนี้：",
		"directly_num_new": "คนในเครือโดยตรง (เพิ่มใหม่)：",
		"zuoriyongjing": "คอมมิชชั่นของเมื่อวาน：",
		"commission_payable": "คอมมิชชั่นที่ถอนได้：",
		"lishizongyong": "ประวัติค่าคอมมิชชั่นทั้งหมด：",
		"zyxtz": "การเดิมพันที่มีประสิทธิภาพทั้งหมด：",
		"agent_commission": "ค่าคอมมิชชั่นตัวแทน",
		"share_commission": "แชร์ค่าคอมมิชชั่น",
		"team_num": "จำนวนสมาชิกในทีม",
		"not_directly_under": "ไม่ใช่การคืนค่าคอมมิชชั่นโดยตรง",
		"account": "บัญชี",
		"between": "ความสัมพันธ์",
		"effective_betting": "การเดิมพันที่มีประสิทธิภาพ / จำนวนเงินคืน",
		"ratio": "อัตราส่วนเงินคืน",
		"total": "ยอดรวม",
		"share": "แชร์",
		"historyCom": "ประวัติคณะกรรมการทั้งหมด",
		"canReceive": "คณะกรรมการที่ได้รับ",
		"contact": "ติดต่อกวดวิชา"
	},
	"WithdrawLayer": {
		"self_help": "การถอนด้วยตนเอง",
		"withdrawal_record": "การบันทึกถอนออก",
		"wallet_management": "การจัดการกระเป๋าเงิน",
		"inp_withdrawal_amount": "โปรดป้อนจำนวนเงินที่ถอน",
		"warm_prompt": "คำเตือนอบอุ่น",
		"current_need_adjust_amount": "ปัจจุบันยังต้องการ<color=#00ff00>0</c>เพื่อถอนเงินก่อนที่จะถอน",
		"current_need": "ปัจจุบันยังต้องการ",
		"can_carry": "มีการบันทึกเงินเข้าออกถึงถอนเงินสดได้",
		"adjust_amount": "กดจุดเพื่อปรับจำนวนการถอน",
		"bank": "ธนาคารอุตสาหกรรมและพาณิชย์",
		"change_bank_card": "เปลี่ยนบัตรธนาคาร",
		"not_bind_card": "คุณไม่ได้ผูกบัตรธนาคารของคุณในขณะนี้โปรดไปผูก",
		"not_tixian_paw": "คุณยังไม่ได้ตั้งรหัสผ่านการถอนโปรดตั้งค่ารหัสผ่านการถอนครั้งแรก",
		"tixian_paw": "รหัสผ่านถอนเงินสด",
		"set6num_paw": "โปรดตั้งรหัสผ่าน 6 หลัก",
		"confirm_password": "ยืนยันรหัสผ่าน",
		"again_confirm_password": "โปรดป้อนรหัสผ่านอีกครั้งเพื่อยืนยัน",
		"inp_tixian_paw": "โปรดป้อนรหัสผ่านการถอน",
		"topUp_failure": "การเติมล้มเหลว",
		"bank_paragraph": "การถอนเงินจากธนาคาร",
		"add_card": "เพิ่มบัตรเครดิตธนาคาร",
		"cardholder_name": "โปรดป้อนชื่อผู้ถือบัตร",
		"cardholder": "ผู้ถือบัตร：",
		"card_code": "หมายเลขบัญชีบัตรเครดิตธนาคาร：",
		"inp_bank_card_code": "โปรดป้อนหมายเลขบัตรเครดิตธนาคาร",
		"inp_bank_address": "โปรดป้อนที่อยู่ธนาคาร",
		"bank_address": "ที่อยู่ของการเปิดบัญชี：",
		"bank_address_msg": "คำเตือน: โปรดเลือกธนาคารบัญชีอย่างถูกต้องและผูกชื่อจริงของคุณ  บัญชีจะถูกโอนโดยตรงไปยังบัญชีในระหว่างการตั้งถิ่นฐานเพื่อความปลอดภัยของเงินทุนของคุณ   คุณไม่สามารถเปลี่ยนได้ที่จะหลังจากผูกพันหากคุณต้องการแก้ไข  โปรดติดต่อฝ่ายบริการลูกค้า ",
		"choose_bank": "การเลือกธนาคาร：",
		"inp_aliPay_name": "โปรดป้อนชื่อจริงของ Alipay",
		"inp_aliPay_code": "โปรดป้อนหมายเลขบัญชี Alipay",
		"name": "ชื่อ：",
		"aliPay_account": "หมายเลขบัญชี Alipay：",
		"aliPay_account_msg": "คำเตือน: โปรดเลือก Alipay อย่างถูกต้องและมันจะถูกโอนโดยตรงไปยังบัญชีที่มีการเปลี่ยนแปลง  ในระหว่างการตั้งถิ่นฐานเพื่อความปลอดภัยของเงินทุนของคุณ   คุณไม่สามารถเปลี่ยนได้ที่จะหลังจากผูกพัน   หากคุณต้องการแก้ไขโปรดติดต่อฝ่ายบริการลูกค้า",
		"inp_tixian_dizhi": "โปรดป้อนที่อยู่การถอนเงินสด",
		"rate": "อัตราแลกเปลี่ยน",
		"daozhangUSDT": "จำนวนเงินในบัญชี USDT",
		"confirm_tixian": "ยืนยันการถอนเงิน",
		"max": "สูงสุด",
		"confirm_submit": "ยืนยันการส่ง",
		"tixian_time": "เวลาถอนเงิน",
		"jine": "ผลรวม",
		"state": "สภาพ",
		"order_info": "ข้อมูลการสั่งซื้อ",
		"confirm_bind": "กำหนดผูกพัน",
		"confirm_select": "กำหนดทางเลือก",
		"select_bank_card": "เลือกบัตรธนาคาร",
		"bizhong_xuanze": "ตัวเลือกสกุลเงิน",
		"tixian_dizhi": "ที่อยู่ปัจจุบัน",
		"more_than_0": "การถอนเงินจะมากกว่า <NU>0"
	},
	"XimaLayer": {
		"selfHelp_washing": "การล้างโค้ดด้วยตัวเอง",
		"xima_record": "บันทึกการล้างโค้ด",
		"xima_proportion": "สัดส่วนการล้างโค้ด",
		"fishing_game": "เกมตกปลา",
		"to_complete": "ไปเพื่อให้เสร็จสมบูรณ์",
		"receive": "รับ",
		"chess": "บัตรหมากรุก",
		"fishing": "ตกปลา",
		"electronic": "อิเล็กทรอนิกส์",
		"reality": "คนตัวจริง",
		"sports": "กีฬา",
		"eSports": "อี - สปอร์ต",
		"lottery": "ลอตเตอรี่",
		"game": "เกม",
		"key_get": "รับด้วยครั้งเดียว",
		"get_time": "เวลารับ",
		"damaliang": "จำนวนเงินเดิมพันที่มีผล",
		"xima_amount": "จำนวนการล้างโค้ด",
		"details": "รายละเอียด",
		"viewI": "เปิดดู>>",
		"xima_details": "รายละเอียดการล้างโค้ด",
		"heitao_chess": "Spades Chess",
		"chess_game": "เกมหมากรุก",
		"sports_events": "กิจกรรมกีฬา",
		"electronic_game": "เกมอิเล็กทรอนิกส์",
		"lottery_betting": "การจับสลากการพนัน",
		"real_video": "วิดีโอคนตัวจริง",
		"eSports_game": "เกมอี - สปอร์ต",
		"game_name": "ชื่อเกม",
		"click_details": "คลิกเพื่อดูรายละเอียด",
		"tianmei_chess": "หมากรุกเทียนเหม่ย",
		"detailsI": "รายละเอียด>>",
		"xima_range": "ขอบเขตการล้างโค้ด",
		"vip_level": "ระดับVip",
		"tournament": "กิจกรรมอี - สปอร์ต",
		"lottery_game": "เกมลอตเตอรี",
		"title": "ล้างรหัส"
	},
	"Signal": {
		"switch": "สลับสาย",
		"speed": "เร่งความเร็วบรรทัด",
		"choose": "การเลือกเส้นทาง",
		"reconnect": "เชื่อมต่อใหม่",
		"helpful_hints": "การแจ้งเตือนที่เป็นมิตร: ยิ่งการล่าช้า เครือข่าย ยิ่งดี",
		"is_msg": "นี่คือข้อความ",
		"in_test": "กำลังทดสอบ",
		"general": "ทั่วไป",
		"smooth": "ราบเรียบ",
		"speed1": "รวดเร็ว",
		"current_use": "ใช้ในปัจจุบัน"
	},
	"general": {
		"name": "ชื่อ",
		"activity": "กิจกรรมรวม",
		"xzsm": "ผู้เผยแพร่ที่อยู่รับที่อยู่การติดตั้งล่าสุดได้ตลอดเวลา",
		"wszl": "กรอกข้อมูลให้สมบูรณ์",
		"qdcj": "ลงชื่อเข้าใช้แจ็คพอต",
		"xtyj": "เมลมาจากทางระบบ",
		"xxzx": "ศูนย์ข้อความ",
		"bt": "ชื่อหัวเรื่อง",
		"sj": "เวลา",
		"nr": "เนื้อหา",
		"xx": "ข้อความ",
		"ready_all": "อ่านทั้งหมด",
		"del_all": "ลบ",
		"dlq": "ต้องการ",
		"ylq": "ได้รับ",
		"ygq": "หมดอายุ",
		"get_all": "ได้รับทั้งหมด"
	},
	"EllipticalStage": {
		"musicNmae": "เพื่อชัยชนะ"
	},
	"CheckHot": {
		"update_msg": "ตรวจพบการอัปเดตเวอร์ชันใหม่และดาวน์โหลดให้คุณ  คลิกเพื่อทำการอัปเดตให้เสร็จสมบูรณ์",
		"update": "อัปเดต",
		"lack_resources": "การขาดทรัพยากรศิลปะ",
		"kaiyuan_chess": "บัตรหมากรุกคายหยวน",
		"leyou_chess": "บัตรหมากรุกลื่อหยิว",
		"xinshijie_chess": "บัตรหมากรุกโลกใหม่",
		"ag_electronic": "AGอิเล็กทรอนิกส์",
		"pg_electronic": "PGอิเล็กทรอนิกส์",
		"mg_electronic": "MGอิเล็กทรอนิกส์"
	},
	"HallUI": {
		"copy_succ": "คัดลอกสำเร็จ",
		"moment_open": "ยังไม่เปิด",
		"no_announcement": "ยังไม่มีเนื้อหาประกาศ",
		"tmpled_err": "การกำหนดค่าแม่แบบผิดโปรดติดต่อฝ่ายบริการลูกค้า",
		"game_maintain": "เกมอยู่ระหว่างการบำรุงรักษา",
		"game_loading": "เกมกำลังโหลด",
		"get_err": "ไม่สามารถรับเหรียญทองคำได้โปรดรีเฟรชเหรียญทองอีกครั้ง",
		"login": " เข้าสู่ระบบ ",
		"register": "ลงทะเบียน",
		"copy_id": "สำเนา ID",
		"huodong": "Activities",
		"buyu": "ประมง",
		"zhenren": "คาสิโน",
		"dianzi": "เกม",
		"tiyu": "กีฬา",
		"caipiao": "หวย",
		"tuiguangdaili": "ทำเงิน",
		"xiaoxi": "กล่องข้อความ",
		"kefu": "การบริการลูกค้า",
		"chongzhi": "เติมเงิน",
		"remenyouxi": "เกมยอดนิยม",
		"zuijingchangwan": "การบันเทิงประวัติ",
		"task": "ภารกิจ",
		"setting": "ตั้งค่า",
		"remen": "ร้อนแรง",
		"qipai": "หมากรุก",
		"dianjing": "การแข่งขันไฟฟ้า",
		"xima": "ล้างรหัส",
		"xiufugongju": "เครื่องมือซ่อมแซม",
		"gengduo": "ยิ่งขึ้น",
		"qiandao": "ทำเครื่องหมาย",
		"paihangbang": "แผนภูมิ",
		"gonggao": "ประกาศ",
		"tixian": "ถอนเงิน",
		"xianshilingqu": "กำหนดเวลา",
		"play_now": "เดิมพันทันที"
	},
	"BasicsJS": {
		"tall": "ยอดรวม",
		"minGame": "เกมเล็ก ๆ ",
		"play_game": "ไม่มีเกมที่เพิ่งเล่นไป",
		"editor_succ": "แก้ไขสำเร็จ",
		"yi_bind": "ผูกพันแล้ว",
		"wu_bind": "ยังไม่ได้มีการผูกพัน",
		"inp_amount": "โปรดป้อนจำนวนเงินที่เติม",
		"inp_correct_amount": "โปรดป้อนจำนวนเงินที่เติมที่ถูกต้อง",
		"no_login_yinshang": "ไม่ได้ลงชื่อเข้าใช้ผู้ค้าธนาคาร",
		"gift": "ของแถม",
		"voucher_cannot_empty": "บัตรกำนัลการชำระเงินต้องไม่ว่างเปล่า",
		"pic_loading": "กำลังโหลดรูปภาพ",
		"amount_between": "จำนวนระหว่าง",
		"card": "บัตร",
		"note_info": "กรอกข้อมูลบันทึกย่อมันจะได้รับเร็วขึ้น",
		"credit_cord": "หมายเลขรับบัตร",
		"rate": "อัตราแลกเปลี่ยน",
		"not_channel": "ช่องทางเติมเงินไม่มีโปรดติดต่อฝ่ายบริการลูกค้า",
		"select_amount": "โปรดเลือกจำนวนเงินที่เติม",
		"confirm_cancellation_order": "คุณแน่ใจที่จะยกเลิกคำสั่งซื้อหรือไม่",
		"been_submit": "ส่งคำสั่งซื้อแล้วโปรดรออย่างอดทน",
		"Eventually_topUp_amount": "การเติมเงินครั้งสุดท้ายกับจำนวนเงินในบัญชีคือ",
		"current_rate": "อัตราแลกเปลี่ยนปัจจุบัน",
		"Outstanding_orders": "คุณมีคำสั่งซื้อที่ยังไม่เสร็จ  คุณต้องการดำเนินการต่อหรือไม่",
		"Continue": "ดำเนินการต่อ",
		"Cancel_order": "ยกเลิกคำสั่งซื้อ",
		"bind_succ": "การผูกพันสำเร็จแล้ว",
		"inp_paw": "โปรดป้อนรหัสผ่านก่อน",
		"remove_bind_succ": "ยกเลิกการผูกสำเร็จ",
		"first": "ที่",
		"day": "วัน",
		"Sports_eSports": "กีฬา อีสปอร์ต",
		"directly": "โดยตรงภายใต้",
		"not_directly": "ไม่ใช่โดยตรงภายใต้",
		"amount_not_null": "จำนวนการถอนไม่สามารถว่างเปล่ากรุณากรอก",
		"WithdrawalAmount": "จำนวนเงินถอน",
		"Qbind": "โปรดผูกก่อน",
		"moment_not_bind": "คุณไม่ได้ถูกผูกมัดในขณะนี้",
		"QgoBind": "โปรดไปผูก",
		"replace": "แทนที่",
		"between": "ระหว่าง",
		"request_submit": "คำขอถอนเงินถูกส่งแล้ว",
		"ContinueToCarry": "ถอนเงินสดต่อไป",
		"GiveUpWithdrawal": "ยกเลิกการถอนเงิน",
		"Qxuanding": "โปรดเลือกอย่างถูกต้อง",
		"jiesuanshihou": "มันจะถูกโอนโดยตรงไปยังสิ่งนี้เมื่อการตั้งถิ่นฐาน",
		"zhuanghaowanquan": "หมายเลขบัญชีเพื่อความปลอดภัยของเงินทุนของคุณจะไม่สามารถเปลี่ยนแปลงได้ตามความประสงค์  หลังจากผูกพันหากคุณต้องการแก้ไขโปรดติดต่อฝ่ายบริการลูกค้า",
		"phoneNo": "หมายเลขโทรศัพท์",
		"add": "เพิ่ม",
		"updateTimeout": "ตรวจสอบการหมดเวลาอัปเดตโปรดตรวจสอบว่าเครือข่ายของคุณเป็นปกติ",
		"retry": "ลองใหม่",
		"err_retry": "เกิดข้อผิดพลาดในการดาวน์โหลดไฟล์โปรดลองอีกครั้ง",
		"err_check_network": "ไม่สามารถดาวน์โหลดไฟล์ได้โปรดยืนยันว่าเครือข่ายของคุณเป็นปกติ",
		"no_get_data": "ยังไม่ได้รับการอัปเดตทรัพยากรโปรดลองอีกครั้งในภายหลัง",
		"network_retry": "เครือข่ายถูกตัดการเชื่อมต่อ  โปรดตรวจสอบว่าการเชื่อมต่อเครือข่ายของคุณเป็นปกติ",
		"Quit_game": "ออกจากระบบเกม",
		"ReturnHall": "กลับถึงที่เติม",
		"daozhangUSDT": "จำนวนเงิน USDT ที่ได้รับ"
	}
};
